"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdminButton", {
    enumerable: true,
    get: function() {
        return AdminButton;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _renderAdminButtonStyles = require("./renderAdminButtonStyles");
const _AdminButtonDropdownToggle = require("./AdminButtonDropdownToggle");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const AdminButton = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { className, children, variant = "primary", size = "md", shape = "default", round, dropdownToggleColor, dropdownToggle = false, inverted = false, type, ...props } = param;
    const theme = (0, _Theme.useTheme)(true);
    const { className: buttonClassName, styles } = (0, _renderAdminButtonStyles.renderAdminButtonStyles)({
        element: "button",
        variant,
        shape: round === true && shape === "default" ? "round" : shape,
        size,
        inverted,
        theme
    });
    return /*#__PURE__*/ _react.default.createElement("button", {
        ref: ref,
        className: "".concat(className !== null && className !== void 0 ? className : "", " ").concat(buttonClassName),
        type: type !== null && type !== void 0 ? type : "button",
        ...props
    }, children, dropdownToggle && /*#__PURE__*/ _react.default.createElement(_AdminButtonDropdownToggle.AdminButtonDropdownToggle, {
        size: size,
        color: dropdownToggleColor
    }), styles);
});
AdminButton.displayName = "Button";

//# sourceMappingURL=AdminButton.js.map